module.exports = __webpack_public_path__ + "static/media/checked.82905800.svg";